import React from 'react';
import './index.scss';
import { getLeftArrowImage } from '../../utils/imageChanges';
import PreMealImage from './PreMealImage';
import Icon from './Icon';
import { FooterButton } from './molecules';
import usePrebookInfo from '../../hooks/usePrebookInfo';

export const PrebookModalHeader = ({ onGoBack, title }) => {
  const handleGoBack = () => {
    if (typeof onGoBack === 'function') {
      onGoBack();
    }
  };

  return (
    <div className="avengers__header">
      <button
        type="button"
        className="avengers__back-icon"
        onClick={handleGoBack}
      >
        <img src={getLeftArrowImage()} alt="Back" />
      </button>
      <h1 className="avengers__header-title">{title}</h1>
    </div>
  );
};

const AvengersDoomsday = ({ onGoBack, item, onPreBook }) => {
  const { preBook } = usePrebookInfo();
  const handlePreBook = () => {
    if (typeof onPreBook === 'function') {
      onPreBook(true, item, false, [], 'normal');
    }
  };

  return (
    <div className="avengers">
      <PrebookModalHeader onGoBack={onGoBack} title="Avengers Doomsday Meal" />
      <div className="avengers__outer-wrapper">
        <PreMealImage
          className="avengers__banner"
          imageUrls={item?.image_urls}
          category="hpiv"
          alt={item?.name}
        />
        <div className="avengers__wrapper">
          <p className="avengers__offer-title">LIMITED-TIME MEAL</p>
          <h1 className="avengers__meal-title">{item?.name}</h1>
          <p className="avengers__meal-description">
            {item?.description ||
              'A guaranteed meal for the day Doomsday arrives.'}
          </p>

          <div className="avengers__price-con">
            <span className="title">One guaranteed meal</span>
            <span className="price">₹ {item?.variant?.actual_price}/-</span>
          </div>
          <div className="avengers__info-con">
            <div className="icon-con">
              <Icon name="info" className="icon" />
            </div>
            <div className="info-con">
              <p className="title">Before you pre-book</p>
              <p className="description">
                Dine-in redemption only; no store selection needed now.
              </p>
              <p className="description">Unlocks {preBook?.unLocksAt}.</p>
              <p className="description">
                Limited to one pre-book per account.
              </p>
              <p className="description">
                Valid until {preBook?.redeemUntil}. Refund terms apply.
              </p>
            </div>
          </div>
        </div>
      </div>
      <FooterButton onClick={handlePreBook}>Pre-book now</FooterButton>
    </div>
  );
};

export default AvengersDoomsday;
